import axiosSecure from "@api/axiosSecure";
import getContextRoot from "@api/getContextRoot";

const deleteFoodPairing = async (foodPairingId: number | string): Promise<any> => {
    const res = await axiosSecure.delete(`${getContextRoot()}/foodPairing/${foodPairingId}`);
    return res.data;
};

export default deleteFoodPairing;
